<!-- ── Botón flotante ─────────────────────────────────────── -->
<button class="chat-fab" (click)="toggle()" aria-label="Ayuda de HELIX">
  @if (!isOpen) {
    <i class="bi bi-chat-dots-fill fs-4"></i>
  } @else {
    <i class="bi bi-x-lg fs-4"></i>
  }
</button>

<!-- ── Panel de chat ──────────────────────────────────────── -->
@if (isOpen) {
  <div class="chat-backdrop d-md-none" (click)="close()"></div>

  <div class="chat-panel">
    <div class="chat-header">
      <div>
        <div class="fw-semibold">Ayuda de HELIX</div>
        <div class="small text-white-50">Preguntas sobre el sistema y los programas</div>
      </div>
      <button type="button" class="btn-close btn-close-white" (click)="close()" aria-label="Cerrar"></button>
    </div>

    <div class="chat-body">
      @if (messages.length === 0) {
        <div class="chat-empty">
          <i class="bi bi-chat-dots fs-2 d-block mb-2 opacity-50"></i>
          Pregunta cómo funciona HELIX o sobre los programas Gold y Silver.
        </div>
      }
      @for (msg of messages; track trackByIndex($index)) {
        <div class="chat-msg" [class.chat-msg--user]="msg.role === 'user'" [class.chat-msg--error]="msg.isError">
          {{ msg.content }}
        </div>
      }
      @if (pending) {
        <div class="chat-msg chat-msg--pending">
          <span class="spinner-border spinner-border-sm"></span>
        </div>
      }
    </div>

    <div class="chat-input">
      <textarea
        rows="1"
        [(ngModel)]="draft"
        (keydown.enter)="$event.preventDefault(); send()"
        placeholder="Escribe tu pregunta..."
        [disabled]="pending"
      ></textarea>
      <button type="button" class="btn btn-primary" (click)="send()" [disabled]="pending || !draft.trim()">
        <i class="bi bi-send-fill"></i>
      </button>
    </div>
  </div>
}
